// jshint esversion: 8
// import store from '../../../store';
import ErrorParser from '@/utils/ErrorParser';

const raiseError = ({ commit }, e) => {
  var err;
  if (e.response) {
    err = e.response.data;
  } else if (e.request) {
    err = ['Unable to process this request, please try again'];
  } else {
    err = [e.message];
  }
  const Ep = new ErrorParser(err);
  const parsed = Ep.parse();
  parsed.forEach(msg => commit('PUSH_ERROR', Ep.arrangeErrorMessage(msg)));
};

const startRefreshTimer = ({ commit, dispatch }, payload) => {
  const { expire, username, department, location } = payload;
  const now = Date.now();
  // send request 1 second before expiration
  setTimeout(
    () => dispatch(
      'auth/refresh',
      { username, department, location },
      { root: true }
    ),
    expire - now - 5000
  );
  commit('SET_TOKEN_EXPIRATION', expire);
};

export default {
  // refreshStore,
  raiseError,
  startRefreshTimer,
  addNotification: ({ commit }, payload) => commit('ADD_NOTIFICATION', payload),
  removeNotification: ({ commit }, payload) => commit('REMOVE_NOTIFICATION', payload),
  clearError: ({ commit }) => commit('SET_ERROR', []),
  toggleLoading: ({ commit }) => commit('TOGGLE_LOADING'),
  updateProgress: ({ commit }, payload) => commit('UPDATE_PROGRESS', payload)
};
